<template>
  <div class="w w1200">
    <div class="welcometop">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="welcometop_left">
            <h3>欢迎来到腾信智慧商城系统</h3>
            <p>若您还没有填写入驻申请资料,<br/>
              请点击“我要入驻”进行入驻资料填写<br/>
              若您的店铺资料已经填写<br/>
              请点击“店铺详情”进行详细的资料填写<br/>
            </p>

            <el-button type="primary" @click="$router.push('/settleIn/merchantTypeSelect')">我要入驻</el-button>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="welcometop_right">
            <el-image :src="logoimg || require('@/assets/img/loginBg.jpg')"></el-image>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="welcomeTabs" v-loading="loading">
      <el-tabs>
        <el-tab-pane :label="item.title" v-for="item in agreementThreelists" :key="item.bxsaId">
          <p v-html="item.content"></p>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {agreementThreelist, pageConfigImg} from "@/api/xunyou";
export default {
  name: "welcomesystem",
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      loading: false,
      agreementThreelists: [],
      logoimg: '',
    };
  },
  mounted() {
    this.getagreementThreelist()
    this.getpageConfigImg()
  },
  methods: {
    //   获取图片
    getpageConfigImg() {
      pageConfigImg()
        .then((res) => {
          if (res.code == 0) {
            this.logoimg = res.rows[0].configValue
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("查询图片，请稍后再试！");
        });
    },
    // tab列表查询
    getagreementThreelist() {
      console.log("tab列表查询");
      this.loading = true;
      agreementThreelist({
        type: 1 // 1:店铺；2.会员；3：供应商
      }).then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          this.agreementThreelists = res.data

        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询招商规则失败，请稍后再试！");
        });
    },
  },
};
</script>
<style scoped lang='less'>
.welcometop {
  background-color: #81bbff91;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 25px;
  box-sizing: border-box;

  .welcometop_left {
    padding: 10px 25px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;

    h3 {
      font-size: 18px;
    }

    p {
      line-height: 24px;
      margin: 10px 0;
    }
  }

  .welcometop_right {
    .el-image {
      height: 195px;
    }
  }
}
.welcomeTabs{
  padding: 15px;
  min-height: 300px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/welcomesystem.vue